import React, { useEffect, useState } from 'react';
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const ClassAttendanceReport = () => {
  const [classesData, setClassesData] = useState([]); // State for classes data

  useEffect(() => {
    const fetchClassesData = async () => {
      const classesSnapshot = await getDocs(collection(db, 'hvac', 'ClassData', 'Responses'));
      const classesList = classesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })); // Extract class data
      setClassesData(classesList); // Set the classes data state
    };

    fetchClassesData();
  }, []);

  return (
    <div>
      <h2>Class Attendance Report</h2>
      <table>
        <thead>
          <tr>
            <th>Class Name</th>
            <th>Date</th>
            <th>Attendance</th>
          </tr>
        </thead>
        <tbody>
          {classesData.map((classItem) => (
            <tr key={classItem.id}>
              <td>{classItem.className}</td> {/* Assuming className is a field */}
              <td>{classItem.date}</td> {/* Assuming date is a field */}
              <td>{classItem.attendance ? 'Present' : 'Absent'}</td> {/* Assuming attendance is a boolean field */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ClassAttendanceReport;
